import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLarge = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M14.6875 9.3125C15.0938 9.6875 15.0938 10.3438 14.6875 10.7188L8.6875 16.7188C8.3125 17.125 7.65625 17.125 7.28125 16.7188C6.875 16.3438 6.875 15.6875 7.28125 15.3125L12.5625 10L7.28125 4.71875C6.875 4.34375 6.875 3.6875 7.28125 3.3125C7.65625 2.90625 8.3125 2.90625 8.6875 3.3125L14.6875 9.3125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowRightLarge);
export default ForwardRef;
